import React from 'react'
import { connect } from 'react-redux'
import { FormSpy } from 'react-final-form'
import { updateFormState } from '../../actions/form';

const FormStateToRedux = ({ formKey, updateFormState }) => (
  <FormSpy onChange={state => updateFormState(formKey, state)} />
)

export default connect(undefined, { updateFormState })(FormStateToRedux);


// WEBPACK FOOTER //
// ./src/components/form/FormStateToRedux.js